const FROM_APP_SESSION_KEY = "mung:fromApp";

type DeepLinkQuery =
  | string
  | Record<string, string | number | boolean | null | undefined>;

interface OpenMungAppDeepLinkOptions {
  query?: DeepLinkQuery;
  type?: string;
  deepLinkId?: string;
}

const getMungAppScheme = (): "mungstore" | "mungtoday" =>
  import.meta.env.VITE_APP_TYPE === "business" ? "mungstore" : "mungtoday";

const normalizeQuery = (query?: DeepLinkQuery): string => {
  if (!query) return "";

  if (typeof query === "string") {
    return query.startsWith("?") ? query.slice(1) : query;
  }

  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  });
  return params.toString();
};

export const wasOpenedFromMungApp = (): boolean => {
  if (typeof window === "undefined") return false;

  try {
    return window.sessionStorage.getItem(FROM_APP_SESSION_KEY) === "1";
  } catch {
    return false;
  }
};

export const openMungAppDeepLink = (
  path: string,
  options: OpenMungAppDeepLinkOptions = {},
): void => {
  const url = new URL(`${getMungAppScheme()}://action`);
  const query = normalizeQuery(options.query);

  url.searchParams.set("path", path);
  if (query) url.searchParams.set("query", query);
  if (options.type) url.searchParams.set("type", options.type);
  url.searchParams.set(
    "deepLinkId",
    options.deepLinkId || `external-payment-return-${Date.now()}`,
  );

  window.location.href = url.toString();
};
